module.exports = __webpack_public_path__ + "static/media/ma-carriere.5265b0fc.svg";